import * as React from 'react';
import { Numberbox } from 'ui';
import { ScreenField, ScreenFieldProps } from 'app/area/codetable/item/screen-renderer/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';
import { SubstanceConversionFactor } from 'app/area/codetable/item/types-store';
import { createConversionFactorsId } from 'app/area/codetable/item/codetable-item-helpers';

export interface FactorProps extends ScreenFieldProps {
  value: number;
  onChange: (value: number) => void;
  conversionFactor: SubstanceConversionFactor;
}

export const Factor = ({ onChange, translation, readOnlyConfig, validation, value, conversionFactor }: FactorProps) => {

  const validationError = validation[createConversionFactorsId(ScreenField.factor, conversionFactor?.uomConversionType?.value)];

  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  return <div className="col-lg-6 col-sm-12">
    <Numberbox
      componentId="code_factor"
      readOnly={readOnly}
      label={translation ? { text: translation.factor, required: !readOnly } : undefined}
      value={value}
      onChange={onChange}
      useThousand=" "
      minValue={-999999999999999.999999999999999}
      maxValue={999999999999999.999999999999999}
      maxDecimals={15}
      validation={validationError}
      required={!readOnly}
      textInvalidRangeError={translation.must_be_within_range}
    />
  </div>;
};
